
// On utilise une approche robuste pour accéder aux variables d'environnement Vite.
// On vérifie d'abord que import.meta et import.meta.env existent pour éviter le crash.
// Fix: Accessing .env on import.meta using type assertion to any to avoid Property 'env' does not exist on type 'ImportMeta'
export const GA_ID = typeof (import.meta as any) !== 'undefined' && (import.meta as any).env 
  ? (import.meta as any).env.VITE_GA_ID 
  : undefined;

// Déclare gtag pour TypeScript
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const initGA = () => {
  // Si GA_ID est indéfini (variable d'env manquante ou environnement non compatible), on sort silencieusement.
  if (!GA_ID) {
    console.info("Google Analytics : ID non configuré (VITE_GA_ID). Le tracking est désactivé.");
    return;
  }

  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}', {
      send_page_view: false
    });
  `;
  document.head.appendChild(script2);
};

export const trackPageView = (path: string) => {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
  });
};

export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
